"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@heroui/react";
// import { cn } from "@heroui/styles";
import { CopyCheckIcon, CopyIcon } from "lucide-react";
import { useState } from "react";
export function CopyButton(t0) {
  const $ = _c(9);
  const {
    content
  } = t0;
  const [hasCopied, setHasCopied] = useState(false);
  let t1;
  if ($[0] !== content) {
    t1 = () => {
      navigator.clipboard.writeText(content);
      setHasCopied(true);
      setTimeout(() => {
        setHasCopied(false);
      }, 2000);
    };
    $[0] = content;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleCopy = t1;
  let t2;
  if ($[2] !== handleCopy) {
    t2 = () => handleCopy();
    $[2] = handleCopy;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== hasCopied) {
    t3 = hasCopied ? <CopyCheckIcon className="size-3 text-primary-foreground" /> : <CopyIcon className="size-3" />;
    $[4] = hasCopied;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <Button className="size-7" aria-label="Copy code to clipboard" variant="ghost" isIconOnly={true} size="sm" onClick={t2}>{t3}</Button>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}